import {lightBrandPalette} from '../../styles/brandColors';
import {alphas, greys} from '../../styles/colorStyles';
import {colorPrimitive} from '../../styles/primitives/colorPrimitive';
import {lightBackgroundSemanticStyles} from './backgroundSemanticStyles';

export interface TooltipSemanticStyles {
  background: string;
  border: string;

  text: string;
  textSecondary: string;

  textBoxBackground: string;

  button: {
    [TButtonType in 'link' | 'secondary']: {
      textColor: string;
      borderColor: string;
      backgroundColor: string;
      backgroundHoverColor: string;
      disabled: {
        textColor: string;
        borderColor: string;
        backgroundColor: string;
      };
    };
  };
}

export const lightTooltipSemanticStyles = {
  background: colorPrimitive.gray[1000],
  border: colorPrimitive.alpha.transparent,

  text: colorPrimitive.gray.white,
  textSecondary: colorPrimitive.gray[400],

  textBoxBackground: lightBackgroundSemanticStyles.fill.inverse,

  button: {
    secondary: {
      textColor: colorPrimitive.gray.white,
      borderColor: alphas.white30,
      backgroundColor: alphas.transparent,
      backgroundHoverColor: alphas.white20,

      disabled: {
        textColor: alphas.white40,
        borderColor: alphas.white30,
        backgroundColor: alphas.white30,
      },
    },
    link: {
      textColor: greys.white,
      borderColor: alphas.transparent,
      backgroundColor: alphas.transparent,
      backgroundHoverColor: alphas.white20,

      disabled: {
        textColor: greys.shade70,
        borderColor: alphas.transparent,
        backgroundColor: alphas.transparent,
      },
    },
  },
} as const satisfies TooltipSemanticStyles;

export const darkTooltipSemanticStyles = {
  ...lightTooltipSemanticStyles,
  border: colorPrimitive.gray[900],
} as const satisfies TooltipSemanticStyles;

export const upsellTooltipSemanticStyles = {
  backgroundColor: lightBrandPalette.violets.shade100,
  textColor: lightBrandPalette.violets.shade800,
  titleColor: lightBrandPalette.violets.shade900,
  titleIconColor: lightBrandPalette.violets.shade700,
};

export type UpsellTooltipSemanticStyles = typeof upsellTooltipSemanticStyles;
